// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1lnBG","rightAdornment":"Header_rightAdornment__2Z5To"};